__turbopack_context__.v({
  "ManualChapterTitle": "xSiY1a_ManualChapterTitle",
  "ManualChapterTitle__Heading": "xSiY1a_ManualChapterTitle__Heading",
  "ManualChapterTitle__Icon": "xSiY1a_ManualChapterTitle__Icon",
  "ManualChapterTitle__Intro": "xSiY1a_ManualChapterTitle__Intro",
});
